import React from 'react';
import { Heading } from '..';

import classNames from 'classnames';
import css from '../../containers/ListingPage/ListingPage.module.css';

import {
  FaSnowflake,
  FaCouch,
  FaWind,
  FaHome,
  FaGamepad,
  FaBed,
  FaWater,
  FaVolumeMute,
  FaUserTie,
  FaShieldAlt,
  FaFireExtinguisher,
  FaUmbrellaBeach,
  FaPills,
  FaGripLines,
  FaLock,
} from 'react-icons/fa';

// import { MdPets } from 'react-icons/md';
import { GiFirstAidKit, GiSpikedFence, GiVacuumCleaner, GiWhistle } from 'react-icons/gi';
import { PiDog, PiDogFill } from 'react-icons/pi';
import { LuCctv, LuFence } from 'react-icons/lu';
import { MdCleanHands, MdOutlineGrid4X4, MdWbIncandescent } from 'react-icons/md';
import { IoBed } from 'react-icons/io5';
import { SiCcleaner } from 'react-icons/si';
import { TbDeviceCctvFilled, TbDog } from 'react-icons/tb';
import { ImExit } from 'react-icons/im';
import { LiaDoorOpenSolid } from 'react-icons/lia';
import { BsBoundingBoxCircles, BsGrid3X3GapFill } from 'react-icons/bs';
import { MdOutlineGridView } from 'react-icons/md';
import { RiShieldCheckLine } from 'react-icons/ri';

// const facilityDisplayData = {
//   air_conditioned: { name: 'Air-Conditioned Rooms', icon: <FaSnowflake /> },
//   indoor_play: { name: 'Indoor Play Area', icon: <FaHome /> },
//   fenced_yard: { name: 'Fenced Yard', icon: <LuFence /> },
//   group_play: {
//     name: 'Group Play Sessions',
//     icon: (
//       <>
//         <PiDogFill size={10} />
//         <PiDog size={10} />
//       </>
//     ),
//   },
//   games: { name: 'Games & Activities', icon: <FaGamepad /> },
//   nap_time: { name: 'Nap Time', icon: <FaBed /> },
//   training_sessions: { name: 'Training Sessions', icon: <GiWhistle /> },
//   splash_pool: { name: 'Splash Pool', icon: <FaWater /> },
//   luxury_suits: { name: 'Luxury Suites', icon: <FaCouch /> },
//   allergy_free: { name: 'Allergy-Free Zones', icon: <FaWind /> },
//   ventilation_lighting: { name: 'Ventilation Lighting', icon: <MdWbIncandescent /> },
//   bedding_blankets: { name: 'Bedding Blankets', icon: <IoBed /> },
//   quiet_zones: { name: 'Quiet Zones', icon: <FaVolumeMute /> },
//   daily: { name: 'Daily Cleaning and Disinfection', icon: <SiCcleaner /> },
//   twice: { name: 'Twice-Daily Cleaning', icon: <GiVacuumCleaner style={{ fontSize: '20px' }} /> },
//   odor: { name: 'Odor Control Measures', icon: <FaWind /> },
//   pet_safe: { name: 'Pet-Safe Cleaning Products', icon: <MdCleanHands /> },
//   cctv: { name: '24/7 CCTV Monitoring', icon: <LuCctv /> },
//   live_cctv: { name: 'Live CCTV Feed', icon: <TbDeviceCctvFilled /> },
//   staff_supervision: { name: '24/7 Staff Supervision', icon: <FaUserTie /> },
//   fenced: { name: 'Fenced Property', icon: <GiSpikedFence /> },
//   controlled: { name: 'Controlled Access Areas', icon: <FaShieldAlt /> },
//   emergency_exits: { name: 'Emergency Exits', icon: <ImExit /> },
//   fire_safety: { name: 'Fire Safety', icon: <FaFireExtinguisher /> },
//   outdoor_zones: { name: 'Shaded/Weather-Protected Outdoor Zones', icon: <FaUmbrellaBeach /> },
//   entry_exit: { name: 'Separate Entry/Exit for Pets', icon: <LiaDoorOpenSolid size={20} /> },
//   first_aid: { name: 'Pet First Aid Kits', icon: <GiFirstAidKit /> },
//   isolation_area: { name: 'Isolation Area for Sick Pets', icon: <BsBoundingBoxCircles /> },
//   medication_services: { name: 'Medication Administration Services', icon: <FaPills /> },
//   non_slip_floor: { name: 'Non-slip Flooring', icon: <FaGripLines /> },
//   pet_restraints: { name: 'Pet Restraints', icon: <FaLock /> },
//   outdoor_supervision: { name: 'Outdoor Play Area Supervision', icon: <FaUserTie /> },
//   balcony: { name: 'Balcony', icon: <LiaDoorOpenSolid /> },
//   lawn: { name: 'Lawn', icon: <TbDog /> },
//   open_area: { name: 'Open Area', icon: <FaUmbrellaBeach /> },
// };

const facilityDisplayData = {
  air_conditioned: {
    name: 'Air-Conditioned Rooms',
    icon: <FaSnowflake />,
  },

  balcony: {
    name: 'Balcony',
    icon: <LiaDoorOpenSolid />,
  },

  lawn: {
    name: 'Lawn',
    icon: <TbDog />,
  },

  fenced_yard: {
    name: 'Fenced Yard (Front/Back)',
    icon: <LuFence />,
  },

  fire_safety: {
    name: 'Fire Safety',
    icon: <FaFireExtinguisher />,
  },

  emergency_exits: {
    name: 'Emergency Exits',
    icon: <ImExit />,
  },

  cctv: {
    name: '24/7 CCTV Monitoring',
    icon: <LuCctv />,
  },
  
  netting: {
    name: 'Protective Netting',
    icon: <MdOutlineGrid4X4 />,
  },

  anti_skid_tiles: {
    name: 'Anti-Skid Tiles',
    icon: <BsGrid3X3GapFill />,
  },
};

const SectionHighlights = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionhighlights}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.highlightsList}>
        {selectedOptions
          .filter(option => facilityDisplayData[option])
          .map(option => {
            const facility = facilityDisplayData[option];
            return (
              <li key={option} className={css.multiEnumItem}>
                <span className={css.facilityIcon}>{facility?.icon}</span>
                <span>{facility?.name || option}</span>
              </li>
            );
          })}
      </ul>
    </section>
  );
};

export default SectionHighlights;
